//Lamp types
export const PRODUCT_TYPES = {
    1: 'Fixture',
    2: 'Lamp',
    3: 'Power Supply',
    4: 'Control',
    5: 'Accessory',
}

// Lamp filters for airtable recommended base
export const FIXTURE_FILTER = (luminaire, expandedStyles = []) => {
    const styles = expandedStyles.length > 0
        ? [...new Set(expandedStyles)]
        : [luminaire?.fixtureStyle].filter(Boolean)
    const styleFilter = styles.length > 1
        ? `OR(${styles.map(style => `{Style} = '${style}'`).join(', ')})`
        : `{Style} = '${styles[0] ?? ''}'`

    if (expandedStyles.length > 0) return styleFilter

    return `
        {Mount} = '${luminaire?.fixtureMount?.charAt(0).toUpperCase() + luminaire?.fixtureMount?.slice(1)}', 
        {Application} = '${luminaire?.fixtureApplication}',
        ${styleFilter},
        {Lens Type} = '${luminaire?.fixtureLens}',
        {Width (inches)} = '${luminaire?.fixtureWidth}', 
        {Length (inches)} = '${luminaire?.fixtureLength}',
        {Diameter (inches)} = '${luminaire?.fixtureDiameter}', 
        {Depth (inches)} = '${luminaire?.fixtureDepth}'
    `
}
export const FIXTURE_FILTER_MIN = (luminaire) => `
        FIND('${luminaire?.fixtureMount?.charAt(0).toUpperCase() + luminaire?.fixtureMount?.slice(1)}', {Mount})`

const getLampSearchCategories = (luminaire, expandedCategories) => (
    expandedCategories.length > 0
        ? [...new Set(expandedCategories)]
        : [luminaire?.lampCategory]
).filter(Boolean)

export const LAMP_FILTER = (luminaire, expandedCategories = []) => {
    const categories = getLampSearchCategories(luminaire, expandedCategories)
    const categoryFilter = categories.length > 1
        ? `OR(${categories.map(category => `{Category} = '${category}'`).join(', ')})`
        : `{Category} = '${categories[0] ?? ''}'`

    if (expandedCategories.length > 0) return categoryFilter

    return `
        ${categoryFilter},
        {Type} = '${luminaire?.lampCategoryType}',
        {Base Category} = '${luminaire?.lampBaseCategory}',
        {Base Type} = '${luminaire?.lampBaseCategoryType}',
        {Wattage} = '${luminaire?.lampWattage}',
        {CCT (K˚)} = '${luminaire?.lampColorTemperature}',
        {Lens Type} = '${luminaire?.lampLensType}'
    `
}

export const LAMP_FILTER_MIN = (luminaire, expandedCategories = []) => {
    const categories = getLampSearchCategories(luminaire, expandedCategories)

    return categories.length > 1
        ? `OR(${categories.map(category => `FIND('${category}', {Category})`).join(', ')})`
        : `FIND('${categories[0] ?? ''}', {Category})`
}

const getExpandedSearchValues = (originalValue, expandedValues) => (
    expandedValues.length > 0
        ? [...new Set(expandedValues)]
        : [originalValue]
).filter(Boolean)

const createTypeFilter = (values) => values.length > 1
    ? `OR(${values.map(value => `{Type} = '${value}'`).join(', ')})`
    : `{Type} = '${values[0] ?? ''}'`

export const POWER_SUPPLY_FILTER = (luminaire, expandedTypes = []) => createTypeFilter(
    getExpandedSearchValues(luminaire?.powerSupplyType, expandedTypes)
)
export const CONTROL_FILTER = (luminaire, expandedTypes = []) => createTypeFilter(
    getExpandedSearchValues(luminaire?.controlType, expandedTypes)
)
export const ACCESSORIES_FILTER = (luminaire, expandedTypes = []) => createTypeFilter(
    getExpandedSearchValues(luminaire?.accessoryTypeA, expandedTypes)
)

// Company types width subtypes
export const REU_COMPANY_TYPES = {
    11: 'Real Estate',
    12: 'Property Investment',
    13: 'Property Management',
    14: 'Facilities Management',
    15: 'Architecture',
    16: 'REIT',
}

export const SU_COMPANY_TYPES = {
    21: 'Supplier',
    22: 'Luminaire Manufacturer',
    23: 'Distributor',
    24: 'Component Manufacturer',
}

export const EU_COMPANY_TYPES = {
    31: 'Electrical',
    32: 'Electrical Contractor',
    33: 'Electrician',
}
